import React from "react";
import {
  Checkbox as MuiCheckbox,
  CheckboxProps as MuiCheckboxProps,
} from "@material-ui/core";

type CheckboxProps = MuiCheckboxProps;

export const Checkbox = React.forwardRef<unknown, CheckboxProps>(
  ({ readOnly, onChange, checked, ...props }, ref) => {
    return (
      <MuiCheckbox
        onChange={readOnly ? undefined : onChange}
        {...props}
        readOnly={readOnly}
        // if checked is undefined, readOnly seems to take no effect
        checked={!!checked}
      />
    );
  }
);
